export default {
  title: 'Bestillingsmetoder',
  paywall: {
    live_title: '{{name}} er live!',
  },
  tabs: {
    general: 'Generelt',
    pickup: 'Afhentning',
    delivery: 'Levering',
    table_ordering: 'Bordbestilling',
  },
  modals: {
    update_confirmation: {
      title: 'Er du sikker på, at du vil gemme de nye ændringer?',
      buttons: {
        confirm: 'Bekræft',
        cancel: 'Annuller',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Er du sikker på, at du vil deaktivere live-bestillinger?',
        enable: 'Er du sikker på, at du vil slå live-bestillinger TIL?',
      },
      buttons: {
        yes: 'Ja',
        no: 'Nej',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
    table_ordering_saved: 'Bordbestilling gemt',
  },
};
